import React from 'react'
import Header from './header'
import Levels from './levels'
import OurPartners from './our-partners'
import Reviews from './review'
import Getting from './getting'
import Questions from './questions'
import PartnersForm from './partners-form'

export const PartnersRU: React.FC = () => {
  return (
    <>
      <Header />
      <Levels />
      <OurPartners />
      <Reviews />
      <Getting />
      <Questions />
      <PartnersForm />
    </>
  )
}

export default PartnersRU
